let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9MqkJ")).then(() => parcelRequire('8WIBW'));